/** Capacidades por provider WhatsApp — usado pela UI para gating de features. */

export type WhatsAppProviderId = "whatsapp_cloud" | "whatsapp_uazapi";

export interface WhatsAppProviderCapabilities {
  /** Envio 1:1 de botões, lista, enquete, carrossel no chat. */
  interactiveOutbound: boolean;
  /** Enquete nativa (UAZAPI) vs lista disfarçada (Cloud). */
  nativePoll: boolean;
  /** Carrossel interativo. */
  carousel: boolean;
  /** Disparos em massa com tipos interativos. */
  bulkInteractive: boolean;
  /** Templates fora da janela 24h (somente Cloud). */
  templates: boolean;
  /** Exige janela de atendimento 24h para mensagens session. */
  serviceWindow24h: boolean;
}

const CAPABILITIES: Record<WhatsAppProviderId, WhatsAppProviderCapabilities> = {
  whatsapp_cloud: {
    interactiveOutbound: true,
    nativePoll: false,
    carousel: false,
    bulkInteractive: false,
    templates: true,
    serviceWindow24h: true,
  },
  whatsapp_uazapi: {
    interactiveOutbound: true,
    nativePoll: true,
    carousel: true,
    bulkInteractive: true,
    templates: false,
    serviceWindow24h: false,
  },
};

export function getWhatsAppProviderCapabilities(
  provider: string | null | undefined,
): WhatsAppProviderCapabilities | null {
  if (provider === "whatsapp_cloud" || provider === "whatsapp_uazapi") {
    return CAPABILITIES[provider];
  }
  return null;
}

export function supportsInteractiveOutbound(provider: string | null | undefined): boolean {
  return getWhatsAppProviderCapabilities(provider)?.interactiveOutbound === true;
}

export function supportsBulkInteractive(provider: string | null | undefined): boolean {
  return getWhatsAppProviderCapabilities(provider)?.bulkInteractive === true;
}

export function supportsCarousel(provider: string | null | undefined): boolean {
  return getWhatsAppProviderCapabilities(provider)?.carousel === true;
}
